import React from 'react';
import { Link } from 'react-router-dom';
import { ibm, azure } from '../../assets';
import './Certs.css';

export default function Certs() {
    return (
      <>
        <div className='certs-container'>
          <h1>Certifications</h1>
          <div className='cert-link-container'>
            <Link
              to='https://www.credly.com/users/owen-jones.d2e07085/badges'
              target='_blank'
              aria-label='Credly'
              className='cert-link'
            >
              <img src={azure} alt='IBM' className='cert-logo' />
              <img src={ibm} alt='IBM' className='cert-logo' />
            </Link>
          </div>
        </div>
      </>
    );
  }